exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*!\n * Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@font-face {\n  font-family: 'Font Awesome 5 Pro';\n  font-style: normal;\n  font-weight: 900;\n  font-display: block;\n  src: url(" + require("../webfonts/fa-solid-900.eot") + ");\n  src: url(" + require("../webfonts/fa-solid-900.eot") + "?#iefix) format(\"embedded-opentype\"), url(" + require("../webfonts/fa-solid-900.woff2") + ") format(\"woff2\"), url(" + require("../webfonts/fa-solid-900.woff") + ") format(\"woff\"), url(" + require("../webfonts/fa-solid-900.ttf") + ") format(\"truetype\"), url(" + require("../webfonts/fa-solid-900.svg") + "#fontawesome) format(\"svg\"); }\n\n.fa,\n.fas {\n  font-family: 'Font Awesome 5 Pro';\n  font-weight: 900; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/@fortawesome/fontawesome-pro/scss/solid.scss
// module id = 471
// module chunks = 0